<template>
  <div class="active_table">
    <!-- 统计模块 -->
    <div class="left_sta">
      <div class="bg_sta">
        <div class="site bg">
          <div class="value">{{ company_count.siteCount }}</div>
          <span>站点总数</span>
        </div>
        <div class="device bg">
          <div class="value">{{ company_count.deviceCount }}</div>
          <span>设备总数</span>
        </div>
        <div class="rtu bg">
          <div class="value">{{ company_count.rtuCount }}</div>
          <span>分组总数</span>
        </div>
      </div>
      <div class="chart">
        <v-chart :autoresize="true" :options="charts" />
      </div>
    </div>
    <div class="right_sta">
      <div class="warn_mould mould">
        <div class="cicle">{{ company_count.warnCount }}</div>
        <div class="title">今日告警总数</div>
      </div>
      <div class="easy_mould mould">
        <div class="cicle">{{ company_count.easyCount }}</div>
        <div class="title">今日预警总数</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./homePage.scss";

.active_table {
  width: 100%;
  height: 100%;
  padding-top: 2em;
  background-color: #f0f3f8;
  display: flex;
  justify-content: space-around;
}
</style>

<script>
export default {
  data() {
    return {
      company_count: {
        siteCount: 60,
        deviceCount: 200,
        rtuCount: 10,
        warnCount: 1000,
        easyCount: 600
      },
      charts: {
        title: {
          text: "告警及预警统计",
          textStyle: {
            fontWeight: 100
          }
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisLine: {
              lineStyle: {
                color: "#999"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 4,
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#DDD"
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#333"
              }
            },
            nameTextStyle: {
              color: "#999"
            },
            splitArea: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "告警数",
            type: "line",
            data: [],
            lineStyle: {
              normal: {
                width: 8,
                color: {
                  type: "linear",

                  colorStops: [
                    {
                      offset: 0,
                      color: "#ff9fa1" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#ff6f8f" // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                },
                shadowColor: "rgba(72,216,191, 0.3)",
                shadowBlur: 10,
                shadowOffsetY: 20
              }
            },
            itemStyle: {
              normal: {
                color: "#fff",
                borderWidth: 10,
                /*shadowColor: 'rgba(72,216,191, 0.3)',
                shadowBlur: 100,*/
                borderColor: "#ff9fa1"
              }
            },
            smooth: true
          },
          {
            name: "预警数",
            type: "line",
            data: [],
            lineStyle: {
              normal: {
                width: 8,
                color: {
                  type: "linear",

                  colorStops: [
                    {
                      offset: 0,
                      color: "#f1d059" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#fe8c54" // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                },
                shadowColor: "rgba(72,216,191, 0.3)",
                shadowBlur: 10,
                shadowOffsetY: 20
              }
            },
            itemStyle: {
              normal: {
                color: "#fff",
                borderWidth: 10,
                /*shadowColor: 'rgba(72,216,191, 0.3)',
                shadowBlur: 100,*/
                borderColor: "#f1d059"
              }
            },
            smooth: true
          }
        ]
      }
    };
  },
  created() {
    this.getData();
    this.getAllCount(); // 获取站点总数 设备总数 rtu总数
    this.chartsInit3(); // 获取今日告警数 预警数
  },
  methods: {
    getData() {
      this.$api.Park.getWarnTotal(null, ["uuids", "park"]).then(res => {
        if (res.code == 0) {
          let data = res.data;
          let earlyWarnTotalCount = data.earlyWarnTotalCount;
          let warnTotalCount = data.warnTotalCount;
          let dateMap = {};
          earlyWarnTotalCount.map(res => {
            dateMap[res.date] = [res.count, 0];
          });
          warnTotalCount.map(res => {
            if (!dateMap[res.date]) {
              dateMap[res.date] = [0, res.count];
            } else {
              dateMap[res.date][1] = res.count;
            }
          });
          let dateList = [];
          for (let item in dateMap) {
            dateList.push(item);
          }
          // 预警列表
          let eazyList = [];
          // 告警列表
          let warnList = [];
          dateList.sort(function(a, b) {
            return b < a ? 1 : -1;
          });
          dateList.map(value => {
            eazyList.push(dateMap[value][0]);
            warnList.push(dateMap[value][1]);
          });
          this.charts.xAxis[0].data = dateList;
          this.charts.series[0].data = warnList;
          this.charts.series[1].data = eazyList;
        } else {
          this.$Notice.warning({
            title: "图表加载失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    getAllCount() {
      this.$api.Park.getAllCount(null, ["uuids", "park"]).then(res => {
        if (res.code == 0) {
          let siteCount = 0;
          let deviceCount = 0;
          let rtuCount = 0;
          let data = res.data;
          for (let item in data.siteCount) {
            siteCount += data.siteCount[item];
          }
          for (let item in data.siteDeviceCount) {
            deviceCount += data.siteDeviceCount[item];
          }
          for (let item in data.rtuCount) {
            rtuCount += data.rtuCount[item];
          }
          this.company_count.siteCount = siteCount;
          this.company_count.deviceCount = deviceCount;
          this.company_count.rtuCount = rtuCount;
        }
      });
    },
    chartsInit3() {
      // this.getAccessWarnCount()
      // this.$api.Park.getCompanyAllWarnCount(param, ["uuids", "park"])
      this.$api.Park.getCompanyAllWarnCount(null, ["uuids", "park"]).then(
        res => {
          //console.log(res);
          if (res.code == 0) {
            let data = res.data;
            this.company_count.easyCount = this.getCount(
              data.earlyWarnTotalCount
            );
            this.company_count.warnCount = this.getCount(data.warnTotalCount);
          } else {
            this.$Notice.warning({
              title: "左一图表初始化失败",
              desc: res.message || "请联系管理员"
            });
          }
        }
      );
    },
    // 从map中获取总数
    getCount(map) {
      let count = 0;
      for (let item in map) {
        count += map[item];
      }
      return count;
    },
    // 获取告警企业套数
    getAccessWarnCount() {
      return new Promise((resovle, reject) => {
        this.$api.Park.getAccessWarnCount(null, ["uuids", "park"]).then(res => {
          resovle(res);
        });
      });
    }
  }
};
</script>